import * as React from 'react';
import { EventData, useSwipeable } from 'react-swipeable';
import { makeStyles } from '@material-ui/core';
import { lightBrown } from '../theme';
import { useRef, useState } from 'react';
import { Dispatch } from 'react';
import Paper from '@material-ui/core/Paper';
import { InteractionMethod } from '../services/user-interaction';
// import { Swipeable } from 'react-swipeable';

type EventType = 'focus-item' | 'ignore-item' | 'save-item';
export interface SwipeableListAction {
    type: EventType;
    payload: {
        id: string;
    };
}

/*interface SwipeableListProps {
    dispatch: Dispatch<SwipeableListAction>;
    // children: React.ReactElement<SwipeableItemProps> & {key: string} | Array<React.ReactElement<SwipeableItemProps> & {key: string}>;
    children: Array<React.ReactElement<SwipeableItemProps> & {key: string}>;
    // leftBackground?: React.ReactNode;
    // rightBackground?: React.ReactNode;
}*/

const itemWidth = 600;

const useStyles = makeStyles({
    wrapper: {
        position: 'relative',
        overflow: 'visible',
        marginBottom: 8,
        transition: 'height 300ms ease-out',

        '&.removing': {
            overflow: 'hidden',
            height: '0 !important'
        },
        '&.removed': {
            display: 'none'
        },

        'body.with-map &': {
            left: 0,
            right: 0,
            bottom: 0,
            position: 'absolute',

            '@media (max-width: 600px)': {
                marginBottom: 0
            },

            '@media (min-width: 600px)': {
                '& > *': {
                    width: itemWidth,
                    margin: '0 auto',
                    left: 0,
                    right: 0
                }
            }
        }
    },
    item: {
        transition: 'all 300ms ease-out',
        transform: 'translateX(0)',
        zIndex: 1000,

        '& a:focus': {
            outline: 'none'
        },
        '&.selected-item h1 a': {
            textDecoration: 'underline'
        },

        'body.with-map &': {
            '&:not(.selected-item)': {
                // opacity: 0
                display: 'none'
            },
        },
    },
    background: {
        position: 'absolute',
        top: 0,
        bottom: 0,
        width: '100%',
        color: 'white',
        backgroundColor: lightBrown,
        borderRadius: 4,

        '& > *': {
            display: 'table-cell',  // for vertical alignment
            verticalAlign: 'middle',
            padding: 16,
            boxSizing: 'border-box'
        }
    }
}, {name: 'swipeable'});
/*
export default function SwipeableList(props: SwipeableListProps) {
    // leftBackground={props.leftBackground}
    // rightBackground={props.rightBackground}
    return (
        <div className="swipeable-list" >
            {props.children!.map(({key, ...child}) =>
                (<SwipeableItem
                    key={key}
                    dispatch={props.dispatch}
                >
                    {child}
                </SwipeableItem>)
            )}
        </div>
    );
}*/

interface SwipeableItemProps {
    dispatch: Dispatch<SwipeableListAction>;
    data: {id: string};
    selected?: boolean;
    elevation?: number;
    children: React.ReactNode;
    // leftBackground?: React.ReactNode;
    // rightBackground?: React.ReactNode;
    // classes: {[name: string]: any};
}

export default function SwipeableItem(props: SwipeableItemProps) {
    // const { classes } = props;
    const classes = useStyles();
    const wrapper = useRef<HTMLDivElement>(null);
    const background = useRef<HTMLDivElement>(null);
    const [deltaX, setDeltaX] = useState(0);

    // console.info('Item props:', props);

    function onFocus() {
        _dispatch('focus-item');
    }

    const handlers = useSwipeable({
        trackMouse: true,
        onSwiping: (eventData: EventData) => {
            // console.info('swiping', eventData);
            if (deltaX !== 0 || Math.abs(eventData.deltaX) > Math.abs(eventData.deltaY)) {
                eventData.event.preventDefault();
            }

            let item: HTMLElement | null = eventData.event.target as HTMLElement;
            while (item && !item.classList.contains(classes.item)) {
                item = item.parentElement;
            }

            if (deltaX === 0) {
                // begin swiping
                document.body.classList.add('swiping');

                console.info('eventData.event.target:', eventData.event.target);
                console.info('item:', classes.item, item);


                // Center the background content vertically
                if (background.current && item) {
                    console.info('item:', item.offsetHeight, item);
                    const child = background.current.firstElementChild as HTMLElement;
                    if (child) {
                        wrapper.current!.style.height = item.offsetHeight + 'px';
                        child!.style.height = item.offsetHeight + 'px';
                    }
                }
            }
            // TODO: implement save
            if (eventData.deltaX >= 0) {
                setDeltaX(-eventData.deltaX);
            }
        },
        onSwiped: eventData => {
            // console.info('swiped', eventData);
            if (wrapper.current) {
                if (deltaX < -150) {
                    setDeltaX(-400);
                    setTimeout(() => removeItem('swipe'), 300);
                } else {
                    wrapper.current!.style.height = null;
                    // wrapper.current!.classList.remove('swiping');
                    document.body.classList.remove('swiping');
                    setDeltaX(0);
                }
            }
        }
    });
    
    function removeItem(method: InteractionMethod, reason?: string) {
        if (wrapper.current) {
            wrapper.current!.classList.add('removing');
            // wrapper.current!.style.overflow = 'hidden';
            // wrapper.current!.style.height = '0px';
        }
        setTimeout(() => {
            if (wrapper.current) {
                wrapper.current!.classList.add('removed');
            }
            _dispatch('ignore-item', {method, reason});
        }, 300);
    }

    function _dispatch(type: EventType, payload?: {method: InteractionMethod; reason?: string}) {
        props.dispatch({type, payload: {id: props.data.id, ...payload}});
    }

    return (
        <div
            ref={wrapper}
            className={classes.wrapper}
            onMouseDown={onFocus}
        >
            <div
                ref={background}
                className={classes.background}
            >
                {/* TODO: implement save <div>Save</div>*/}
                <div style={{width: '100%'}}/>
                <div>Ignore</div>
            </div>
            <Paper
                elevation={props.selected ? 8 : props.elevation || 1}
                className={classes.item + ' ' + (props.selected ? 'selected-item' : '')}
                style={{
                    transform: `translateX(${deltaX}px)`,
                    opacity: deltaX > 0 ? 1 : (1 + deltaX / 400)
                }}
                {...handlers}
            >
                {props.children}
            </Paper>
            {/*<div className={classes.background}>*/}
            {/*    {props.rightBackground}*/}
            {/*</div>*/}
        </div>
    );
}
